import { ReactNode } from "react";
import { SyndicationFeed } from "api/syndicationFeed";
import { PropertyManagementSystem } from "shared/types/partner";
import type { PaywallFeature } from "shared/app/BoomCrmPaywall/constants";

export interface Integration {
  id: string;
  name: string;
  icon: ReactNode;
  /**
   * Set when the partner lacks the entitlement this integration needs: the row
   * still renders, greyed out, with the paywall card on hover instead of
   * disappearing from the list (CRM-759).
   */
  lockedPaywall?: PaywallFeature;
}

export enum Step {
  FIRST,
  SECOND,
  THIRD,
  CHOOSE_LISTINGS,
  INTEGRATION_NAME
}

export enum IntegrationId {
  GA = "GA",
  GOOGLE_ADS = "GOOGLE_ADS",
  HUBSPOT = "HUBSPOT",
  CODEBOX = "CODEBOX",
  SENTRILOCK = "SENTRILOCK",
  IGLOOHOME = "IGLOOHOME",
  RENTLY_LOCKBOXES = "RENTLY_LOCKBOXES",
  ZILLOW = "ZILLOW",
  ZUMPER = "ZUMPER",
  DWELLSY = "DWELLSY",
  APARTMENTS_COM = "APARTMENTS_COM",
  MHVILLAGE = "MHVILLAGE",
  AFFORDABLE_HOUSING_COM = "AFFORDABLE_HOUSING_COM",
  BOOM_FINANCE = "BOOM_FINANCE",
  META_ADS = "META_ADS",
  RENTAL_BEAST = "RENTAL_BEAST",
  ULOOP = "ULOOP",
  RENTAL_SOURCE = "RENTAL_SOURCE",
  PROPERTY_SHIELD = "PROPERTY_SHIELD"
}

export const isPmsIntegration = (id: string): id is PropertyManagementSystem =>
  (Object.values(PropertyManagementSystem) as string[]).includes(id) &&
  id !== PropertyManagementSystem.Other;

// Integrations that skip the credentials step (direct connect or no creds needed)
export const DIRECT_CONNECT_INTEGRATIONS = new Set<
  PropertyManagementSystem | IntegrationId
>([
  IntegrationId.ZILLOW,
  IntegrationId.ZUMPER,
  IntegrationId.DWELLSY,
  IntegrationId.APARTMENTS_COM,
  IntegrationId.MHVILLAGE,
  IntegrationId.BOOM_FINANCE,
  IntegrationId.RENTAL_BEAST,
  IntegrationId.RENTAL_SOURCE
]);

export const SYNDICATION_FEED_BY_INTEGRATION: Partial<
  Record<IntegrationId, SyndicationFeed>
> = {
  [IntegrationId.ZILLOW]: "zillow",
  [IntegrationId.ZUMPER]: "zumper",
  [IntegrationId.DWELLSY]: "dwellsy",
  [IntegrationId.APARTMENTS_COM]: "apartments_com",
  [IntegrationId.RENTAL_BEAST]: "rental_beast",
  [IntegrationId.ULOOP]: "uloop",
  [IntegrationId.RENTAL_SOURCE]: "rental_source"
};
